import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  fetchhsnCodeById,
  fetchhsnCodes,
  addhsnCode,
  updatehsnCode,
  updateStatusInhsnCode,
} from "./thunk";

interface HSNCodeState {
  hsnCodeList: any[];
  rowCount: number;
  loading: boolean;
  error: any;
  selectedHSNCode: any;
}

const initialState: HSNCodeState = {
  hsnCodeList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedHSNCode: null,
};

const hsnCodeSlice = createSlice({
  name: "hsnCode",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchhsnCodes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchhsnCodes.fulfilled, (state, action) => {
        state.loading = false;
        state.hsnCodeList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchhsnCodes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch packages";
      })
      .addCase(fetchhsnCodeById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchhsnCodeById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedHSNCode = action.payload;
      })
      .addCase(fetchhsnCodeById.rejected, (state, action) => {
        state.loading = false;
        const errorPayload = action.payload as any;
        state.error = typeof errorPayload === "string" 
          ? errorPayload 
          : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to fetch HSN Code by ID";
      })
      .addCase(updatehsnCode.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.hsnCodeList = state.hsnCodeList.map((dist) =>
          dist.id === action.payload.id ? action.payload : dist
        );
        state.error = null;
      })
      .addCase(updatehsnCode.rejected, (state, action) => {
        state.loading = false;
        const errorPayload = action.payload as any;
        state.error = typeof errorPayload === "string" 
          ? errorPayload 
          : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to update HSN Code";
      })
      .addCase(addhsnCode.fulfilled, (state) => {
        state.error = null;
      })
      .addCase(addhsnCode.rejected, (state, action) => {
        state.loading = false;
        const errorPayload = action.payload as any;
        state.error = typeof errorPayload === "string" 
          ? errorPayload 
          : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to add HSN Code";
      })
      .addCase(updateStatusInhsnCode.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.hsnCodeList = state.hsnCodeList.map((dist) =>
        //   dist.id === action.payload.id ? action.payload : dist
        // );
      })

      .addCase(updateStatusInhsnCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch packages";
      });
  },
});

export default hsnCodeSlice.reducer;
